// extracted by mini-css-extract-plugin
export default {"container":"AppHeader_container__0mHHY","rowContainer":"AppHeader_rowContainer__uRfyG","normalText":"AppHeader_normalText__Wvzcj","lateralPadding":"AppHeader_lateralPadding__0v5Nl"};